/* eslint-disable no-unused-vars */
export enum LoadingActions {
  SET_LOADING = '@loading/ SET_LOADING'
}

export type LoadingState = {
  isLoading: boolean
}
